/**
 * ResetDefaultsButton Component
 * 
 * Button to reset all settings to default configuration
 */

import React from 'react';
import { ArrowClockwise } from 'react-bootstrap-icons';
import './ResetDefaultsButton.scss';

interface ResetDefaultsButtonProps {
  onReset: () => void;
}

const ResetDefaultsButton: React.FC<ResetDefaultsButtonProps> = ({ onReset }) => {
  return (
    <div className="form-group">
      <button onClick={onReset} className="submit-reset-button-style">
        <ArrowClockwise /> Configuración por defecto
      </button>
    </div>
  );
};

export default ResetDefaultsButton;
